import { supabase } from '../../../lib/supabaseClient';

export async function getASPAuditTrail(aspId) {
  const { data, error } = await supabase
    .rpc('get_asp_audit_trail', {
      p_asp_id: aspId
    });

  if (error) throw error;
  return data;
}

export async function getASPEvents(aspId) {
  const { data, error } = await supabase
    .from('asp_events')
    .select('*')
    .eq('asp_id', aspId)
    .order('created_at', { ascending: true });

  if (error) throw error;
  return data || [];
}
